// extracted by mini-css-extract-plugin
export var logo = "_8g-2";
export var logoWrapper = "_8g-1";
export var strip = "_8g-0";